import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

// Blade dashboard path — শুধু attendee ছাড়া বাকি role-দের জন্য।
const DASHBOARD_PATH = {
  admin: "/admin/dashboard",
  organizer: "/organizer/dashboard",
  vendor: "/vendor/dashboard",
  staff: "/staff/dashboard",
};

// লগইন থাকলে নাম + dropdown (My Bookings/Favorites/Tickets/Profile/Logout),
// না থাকলে Login/Register লিংক — main-menu এর ডান পাশে বসে।
//
// Admin/Organizer/Vendor/Staff এর জায়গা এই React frontend না, তাদের নিজস্ব
// Blade dashboard। কেউ যদি (session shared থাকায়) ভুলবশত frontend-এ চলে
// আসেন, তখন এখানে attendee-এর মেনু (My Bookings ইত্যাদি) বা "Log out"
// না দেখিয়ে শুধু তার আসল dashboard-এর লিংক দেখানো হয় — logout সেখান
// থেকেই করা উচিত, যাতে ভুলবশত session/cookie নিয়ে বিভ্রান্তি না হয়।
export default function AccountMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!user) {
    return (
      <div className="main-menu__account-box" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Link to="/login">Log in</Link>
        <Link to="/register" className="thm-btn" style={{ padding: "8px 18px" }}>
          Sign up
        </Link>
      </div>
    );
  }

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate("/");
  };

  const isAttendee = user.role === "attendee";
  const dashboardPath = DASHBOARD_PATH[user.role];

  return (
    <div className="main-menu__account-box" style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontWeight: 600,
          color: "#ffffff",
          fontSize: "15px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {user.name} ▾
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            background: "#fff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
            borderRadius: "6px",
            minWidth: "180px",
            zIndex: 50,
            padding: "8px 0",
          }}
        >
          {isAttendee ? (
            <>
              <Link to="/my-bookings" onClick={() => setOpen(false)} style={{ display: "block", padding: "8px 16px" }}>
                আমার বুকিং
              </Link>
              <Link to="/my-favorites" onClick={() => setOpen(false)} style={{ display: "block", padding: "8px 16px" }}>
                Favorites
              </Link>
              <Link to="/notifications" onClick={() => setOpen(false)} style={{ display: "block", padding: "8px 16px" }}>
                Notifications
              </Link>
              <Link to="/profile" onClick={() => setOpen(false)} style={{ display: "block", padding: "8px 16px" }}>
                প্রোফাইল
              </Link>
              <button
                onClick={handleLogout}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "8px 16px",
                  background: "none",
                  border: "none",
                  borderTop: "1px solid #eee",
                  cursor: "pointer",
                }}
              >
                Log out
              </button>
            </>
          ) : (
            <a href={dashboardPath} style={{ display: "block", padding: "8px 16px" }}>
              {user.role} ড্যাশবোর্ডে যান
            </a>
          )}
        </div>
      )}
    </div>
  );
}
